module.exports = __webpack_public_path__ + "static/img/performance02.0f6d0447.jpg";